//@import dependencies
import React from 'react'
import { useTranslation } from 'react-i18next'
import {FaRegEnvelope} from "react-icons/fa"
import {RiFacebookBoxLine, RiTwitterLine, RiLinksLine} from "react-icons/ri";
//@end

//@import components
//@end

// @import hooks
// @end

// @INFO Import types
// @end

// @INFO Import services
// @end

// @INFO Import Styles
import './../socialCommon.scss'

// @ADD Component types
interface ISocialCommonLayoutProps {}

const SocialCommonLayout: React.FC<ISocialCommonLayoutProps> = (props) => {

  const { t } = useTranslation()

  return(
    <div className='social-icons'>
    	<FaRegEnvelope/>
    	<div className={'separador'}></div>
    	<RiFacebookBoxLine/>
    	<div className={'separador'}></div>
    	<RiTwitterLine/>
    	<div className={'separador'}></div>
    	<RiLinksLine/>
    </div>
  )
}

export default SocialCommonLayout
